import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">分类索引</h2>
        <p className="section-subtitle">按类型快速浏览，发现你喜欢的电视剧品类</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexData.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group flex items-center gap-4 bg-background-100 border border-background-200/70 rounded-lg p-4 md:p-5 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className="ri-movie-2-line text-xl text-primary-600"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm md:text-base font-heading text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-primary-600 font-medium whitespace-nowrap ml-2">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}